export enum EditMode {
  Organization = "Organization",
  Governance = "Governance",
}
